import { Table as MantineTable } from '@mantine/core';
import { GoodTable } from './table';
import { GoodTableTd } from './table-td';
import { GoodTableTh } from './table-th';
GoodTable.Tr = MantineTable.Tr;
GoodTable.Th = GoodTableTh;
GoodTable.Td = GoodTableTd;
GoodTable.Tbody = MantineTable.Tbody;
GoodTable.Thead = MantineTable.Thead;
GoodTable.Tfoot = MantineTable.Tfoot;
GoodTable.Caption = MantineTable.Caption;
GoodTable.ScrollContainer = MantineTable.ScrollContainer;
GoodTable.DataRenderer = MantineTable.DataRenderer;
export * from './types';
export { GoodTable };
